import { useState, useRef, useEffect } from "react";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import {
  AiFillCloseCircle,
  AiOutlineCreditCard,
  AiOutlineDown,
  AiOutlineShareAlt,
  AiOutlineUp,
} from "react-icons/ai";
import { EmptySkill } from "./dashboard";
import HelpCenter from "../reusble_components/helpCenter";
import { IoTicketOutline } from "react-icons/io5";
// import Lottie from "react-lottie";
import { FaCoins, FaPercentage } from "react-icons/fa";
import { useObserver } from "mobx-react";
import UserData from "./UserData";
import BasicDetailsMobile from "./BasicDetailsMobile";
import Loader from "../reusble_components/loader";
import { Prof } from "./Prof";
import DeletePopup from "../recruiter/DeletePopup";
import GetCreditsNewPopup from "./GetCreditsNewPopup";
import { FaArrowLeftLong } from "react-icons/fa6";
import VersionDisplay from "../reusble_components/VersionDisplay";
export default function BasicDetails({ onSave }) {
  // const userUpdatedDetails = JSON.parse(localStorage.getItem("user"));
  const nameInputRef = useRef(null);
  const collegeInputRef = useRef(null);
  const departmentInputRef = useRef(null);
  const yearInputRef = useRef(null);
  const designationInputRef = useRef(null);
  const [role, setRole] = useState(null);
  const [skills, setSkills] = useState([]);
  const [showSkills, setShowSkills] = useState(true);
  const [newUi, setnewUi] = useState(true);
  const { UserStore } = useStores();
  const skillInputRef = useRef(null);
  const studentId = "647ce2e8c41bee677ea39fc4";
  const employeeId = "650befd08b98acd1edca13a8";
  const navigate = useNavigate();
  const userGoogleDetails = JSON.parse(localStorage.getItem("user_google"));
  const userId = JSON.parse(localStorage.getItem("user"));
  const profile = userGoogleDetails?.picture;
  const [pic, setPic] = useState(profile);
  const [name, setName] = useState();
  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";

  useEffect(() => {
    autofillRef();
    checkScreenWidth();
  }, []);

  function checkScreenWidth() {
    if (window.innerWidth >= 1000) {
      setnewUi(true);
    } else {
      setnewUi(true);
    }
  }

  const autofillRef = () => {
    // get data from local storage
    // set data to input fields

    // const userDetails = JSON.parse(localStorage.getItem("user"));

    try {
      nameInputRef.current.value = UserStore?.userDetails?.name ?? "";
      collegeInputRef.current.value = UserStore?.userDetails?.college ?? "";
      departmentInputRef.current.value = UserStore?.userDetails?.branch ?? "";
      yearInputRef.current.value = UserStore?.userDetails?.year ?? "";
      designationInputRef.current.value =
        UserStore?.userDetails?.designation ?? "";
      setSkills(UserStore?.userDetails?.skills ?? []);
      setRole(UserStore?.userDetails?.role?.role ?? "");
    } catch (error) {}
  };

  const addSkills = () => {
    setShowSkills(true);
    if (skillInputRef.current.value !== "") {
      setSkills([...skills, skillInputRef.current.value]);
    }

    skillInputRef.current.value = "";
    // setSkills("");
  };

  const removeSkill = (skill) => {
    setSkills(skills.filter((item) => item !== skill));
  };

  const showProfile = (e) => {
    e.preventDefault();
    if (role === null || role === "") {
      alert("Please select your role");
      return;
    }
    UserStore.UpdateUserDetails(
      nameInputRef?.current?.value,
      collegeInputRef?.current?.value,
      departmentInputRef?.current?.value,
      yearInputRef?.current?.value,
      designationInputRef?.current?.value,
      skills,
      role === "student" ? studentId : employeeId
    );
    if (onSave) {
      onSave();
    } else {
      navigate("/dashboard/dashboard");
    }
    console.log("name", nameInputRef?.current?.value);
    console.log("college", collegeInputRef?.current?.value);
    console.log("department", departmentInputRef?.current?.value);
    console.log("year", yearInputRef?.current?.value);
    console.log("designation", designationInputRef?.current?.value);
    console.log("skills", skills);
    console.log("role", role);
    nameInputRef.current.value = "";
    collegeInputRef.current.value = "";
    departmentInputRef.current.value = "";
    yearInputRef.current.value = "1";
    designationInputRef.current.value = "";
    skillInputRef.current.value = "";
    setSkills([]);
    setShowSkills(false);
  };

  return (
    <div>
      {!newUi ? (
        <div className="flex md:flex-row w-[100%] lg:flex-row justify-between flex-col md:mt-[4%] lg:mt-[4%] mt-0">
          {UserStore?.DeletePopup && <DeletePopup />}
          <form
            className="flex flex-col w-[90%] my-auto md:mx-0 lg:mx-0 mx-auto lg:w-[60%] md:w-[60%] items-end "
            onSubmit={showProfile}
          >
            <div className="flex flex-row justify-start w-full lg:w-[85%] md:w-[85%]">
              <button
                type="button"
                className={`${
                  role === "student"
                    ? "bg-primary text-bg3"
                    : "bg-primary2 text-text_color3"
                } w-[100px] px-5 py-2 rounded-[10.49px] m-2 text-center `}
                onClick={() => setRole("student")}
              >
                Student
              </button>
              <button
                type="button"
                className={`${
                  role === "employee"
                    ? "bg-primary text-bg3"
                    : "bg-primary2 text-text_color3"
                } w-[100px] px-5 py-2 rounded-[10.49px] m-2 text-center `}
                onClick={() => setRole("employee")}
              >
                Employee
              </button>
            </div>
            <div className="w-[100%] flex flex-col justify-center items-center">
              <div className="md:w-[70%] lg:w-[70%] w-[100%] p-2">
                <label className="text-text_color4" htmlFor="name">
                  Enter your name
                </label>
                <input
                  type="text"
                  required
                  className="w-full p-2 border border-border2 rounded-[10px] focus:outline-none"
                  ref={nameInputRef}
                />
              </div>
              <div className="md:w-[70%] lg:w-[70%] w-[100%] p-2">
                <label className="text-text_color4" htmlFor="college">
                  Enter your college name
                </label>
                <input
                  type="text"
                  required
                  className="w-full p-2 border border-border2 rounded-[10px] focus:outline-none"
                  ref={collegeInputRef}
                />
              </div>
              <div className="md:w-[70%] lg:w-[70%] w-[100%] p-2">
                <label className="text-text_color4" htmlFor="department">
                  Department(Branch)
                </label>
                <input
                  type="text"
                  required
                  className="w-full p-2 border border-border2 rounded-[10px] focus:outline-none"
                  ref={departmentInputRef}
                />
              </div>
              <div className="md:w-[70%] lg:w-[70%] w-[100%] p-2">
                <label className="text-text_color4" htmlFor="year">
                  Year
                </label>
                {/* <input
                            type="text"
                            required
                            className="w-full p-2 border border-border2 rounded-[10px] focus:outline-none"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                        /> */}
                <select
                  className=" w-full p-2 border border-border2 rounded-[10px] focus:outline-none"
                  ref={yearInputRef}
                >
                  <option defaultChecked={true}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </select>
              </div>
              <div className="md:w-[70%] lg:w-[70%] w-[100%]  mb-auto p-2">
                <label className="text-text_color4" htmlFor="designation">
                  Designation
                </label>
                <input
                  type="text"
                  required
                  className="w-full p-2 border border-border2  rounded-[10px] focus:outline-none"
                  ref={designationInputRef}
                />
              </div>
              <div className="md:w-[70%] lg:w-[70%] w-[100%]  flex flex-col p-2">
                <label className="text-text_color4" htmlFor="skills">
                  skills you have{" "}
                </label>
                <div className="flex flex-row">
                  <input
                    type="text"
                    ref={skillInputRef}
                    className="w-full p-2 border border-border2 rounded-[10px] focus:outline-none"
                    // value={skills}
                    // onChange={(e) => setSkills([...skills, e.target.value])}
                  />
                  <button
                    onClick={() => addSkills()}
                    type="button"
                    className="bg-primary  text-bg3 mx-1 py-2 px-4 rounded-[10px] cursor-pointer transition-colors duration-300"
                  >
                    Add
                  </button>
                </div>

                {skills.length === 0 ? (
                  <>
                    <EmptySkill />
                  </>
                ) : (
                  <>
                    {showSkills && (
                      <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                        {skills.map((skill, index) => (
                          <div
                            className="flex relative flex-row justify-end pt-2"
                            key={index}
                          >
                            {/* <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div> */}
                            <AiFillCloseCircle
                              className="absolute cursor-pointer md:my-0 lg:my-0 mb-2 mr-[-10px]"
                              onClick={() => {
                                removeSkill(skill);
                              }}
                            />
                            <p className="text-[15px]   rounded-lg  bg-primary  text-bg3 py-1 px-4">
                              {skill}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className=" md:w-[80%] lg:w-[80%] w-[100%]  md:mr-[2%] lg:mr-[2%] my-4">
              <button
                type="submit"
                className=" md:ml-0 lg:ml-0 ml-[35px] border font-bold mx-auto border-primary w-[80%] text-md hover:border-0 hover:text-bg3 hover:bg-primary text-primary bg-white rounded-[10px] px-4 py-2 "
              >
                Save
              </button>
            </div>
          </form>
          <RedeemCoupon />
          <div className="md:block lg:block hidden">
            <HelpCenter />
          </div>
        </div>
      ) : (
        <div className="">
          <div className="block md:hidden lg:hidden  ">
            <BasicDetailsMobile></BasicDetailsMobile>
          </div>
          <div className="hidden md:block lg:block ">
            <HelpCenter />
            <div className="flex flex-col   ">
              {/* <UserDetails className="bg-white "></UserDetails> */}
              <div className="px-6 pl-10 relative flex items-center justify-between  h-36  bg-[#FBF7F2]">
                <VersionDisplay isCompany={false} />
                <div className="absolute top-20">
                  <Prof pic={pic} size="80px" />
                </div>
                <div className="mt-24">
                  <span className="  ml-24 text-lg font-semibold ">
                    {UserStore?.userDetails?.name ?? "-"}
                  </span>
                  <p className=" ml-24  text-[9px] font-normal text-primary">
                    ID: {userId?._id}
                  </p>
                </div>
              </div>

              <UserData className="bg-white "></UserData>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function RedeemCoupon({
  popUpInitialValue,
  handlePopup,
  InitialvalueofShow,
  onClick,
}) {
  const [popup, setPopup] = useState(popUpInitialValue);
  const [show, setShow] = useState(InitialvalueofShow);
  const coderef = useRef(null);
  const [isBlasted, setIsBlasted] = useState(false);
  const [showCoupons, setShowCoupons] = useState(false);
  const { UserStore } = useStores();
  const [loading, setLoading] = useState(false);
  const { PopupStore, InterviewStore } = useStores();

  const onClickDown = () => {
    // UserStore.fetchCoupons();
    setShowCoupons(!showCoupons);
  };

  const closePopUp = () => {
    setPopup(!popup);
    if (handlePopup) {
      return handlePopup();
    }
    setShow(!show);
  };

  const redeemCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(coderef.current.value);
    const coupon = coderef.current.value;
    let company_id;

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      company_id = user?._id;
      console.log(company_id);
    } catch (error) {
      console.log("error occurred getting id", error);
    }

    const id = UserStore?.userDetails?._id ?? company_id;

    const resp = await UserStore.postRedeemCoupon(coupon, id);
    coderef.current.value = "";

    setLoading(false);
    if (resp) {
      closePopUp();
    }

    // if (resp) {
    //   setIsBlasted(true);
    //   setTimeout(() => {
    //     setIsBlasted(false);
    //   }, 1000);
    //   coderef.current.value = "";
    // } else {
    //   coderef.current.value = "";
    // }
  };

  const expiryDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const fillInputWithCode = (code) => {
    coderef.current.value = code;
    setShowCoupons(!showCoupons);
  };

  const redeemButton = () => {
    onClick && onClick();
    setPopup(true);
    setShow(false);
  };
  const handleGoBack = () => {
    PopupStore.setGetMoreCredits(true);
    PopupStore.setRedeemCoupon(false);
  };

  return useObserver(() => (
    <>
      {show ? (
        <div className=" flex flex-col rounded-lg pb-8 justify-center items-center md:w-[25%] lg:w-[25%] w-[90%] h-full m-auto  ">
          {/* <div className="flex flex-col items-center justify-center w-[100%] h-full rounded-t  py-10 bg-primary">
                        <IoTicketOutline className="text-bg3 pb-2 text-5xl border-b-2 border-bg3" />
                        <p className="text-bg3 font-semibold mt-2 text-3xl">70% OFF</p>
                        <p className="text-bg3 font-semibold p-2 text-xl">Claim Or Redeem</p>

                    </div> */}
          <div className="flex flex-col items-center  w-[100%] h-full ">
            {/* <p className="w-[85%] py-3"> Click on  REDEEM COUPON button to get free coupon or to claim your coupon.</p> */}
            <button
              className="mt-2 flex items-center rounded-xl justify-center bg-primary hover:bg-primary2 border-full text-lg text-white font-semibold  hover:text-primary hover:border hover:border-primary py-2 px-4 w-full hover:border-transparent "
              onClick={redeemButton}
            >
              <IoTicketOutline className="mr-4 underline text-2xl" />
              Redeem Coupon
            </button>
          </div>
        </div>
      ) : null}

      {popup ? (
        <>
          {loading ? <Loader loader={true} /> : null}
          <div
            className="absolute w-screen h-screen z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
            onClick={closePopUp}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="fixed  inset-0 bg-bg3 z-40 flex flex-col justify-center rounded items-center md:w-[25%] lg:w-[25%] w-[90%] h-[65vh] m-auto  overflow-y-auto no-scrollbar"
            >
              <div className="flex flex-col  items-center justify-center w-[100%] h-full   py-10 ">
                <FaArrowLeftLong
                  className="text-primary text-2xl cursor-pointer absolute top-4 left-4"
                  onClick={handleGoBack}
                />
                <AiFillCloseCircle
                  onClick={closePopUp}
                  className="text-primary absolute text-2xl cursor-pointer  top-4 right-4"
                />
                {/* <Lottie
                            options={defaultOptions}
                            height={200} // Adjust the height of the Lottie animation as needed
                            width={200} // Adjust the width of the L    ottie animation as needed
                        /> */}
                <IoTicketOutline className="text-primary  text-5xl border-b-2 border-bg3" />
                <p className="text-black font-semibold mt-3 text-2xl">
                  Have a Coupon Code?
                </p>
                {/* <p className="text-black font-semibold mt-1 text-3xl">40% OFF</p> */}
                {/* <p className="text-black  p-1 text-xl">Until dd/mm/year</p> */}
              </div>
              <form
                className="flex flex-col items-center   w-[100%] h-full   "
                onSubmit={redeemCode}
              >
                {/* <p className="w-[90%] ">Hurry, our coupon expires on 01/01/2024. Don't miss out on the savings! Extend your savings by redeeming your coupon before 01/01/2024.</p> */}
                <input
                  type="text"
                  ref={coderef}
                  required
                  className="w-[50%] p-2 border border-border2  focus:outline-none"
                  placeholder="Enter your coupon code"
                />
                <button
                  type="submit"
                  className="mt-6   bg-primary2 hover:bg-primary text-lg text-primary font-semibold  hover:text-bg3 py-2 px-4 w-[55%] hover:border-transparent "
                >
                  Redeem
                </button>
              </form>
              {/* {isBlasted && (
          <div className="absolute top-16 left-0 w-full h-full">
            <Lottie
              options={{
                animationData: animationData,
                loop: false,
              }}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: () => setIsBlasted(false),
                },
              ]}
            />
          </div>
        )} */}

              {showCoupons && (
                <p
                  onClick={onClickDown}
                  className="w-[90%] cursor-pointer text-primary mt-1 mb-4 items-center flex text-base"
                >
                  Don't have a coupon code? Get it here!!{" "}
                  {showCoupons ? (
                    <AiOutlineUp
                      onClick={() => setShowCoupons(false)}
                      className="text-black ml-2"
                    />
                  ) : (
                    <AiOutlineDown className="text-black ml-2" />
                  )}
                </p>
              )}
              {showCoupons ? (
                <>
                  <div className="flex flex-col w-[90%]  py-2 ">
                    {UserStore?.coupons?.map((coupon, index) => {
                      return (
                        <div
                          key={index}
                          className="flex w-full p-3 h-full py-3 justify-between items-center bg-primary2 border-2 border-primary "
                        >
                          <div className="bg-primary w-10 h-10 flex justify-center items-center">
                            <FaPercentage className="text-bg3 " />
                          </div>
                          <div className="flex flex-col mx-1 w-[70%] justify-around items-start">
                            <p className="font-bold text-md">{coupon?.code}</p>
                            <p className="text-opacity-60 text-xs">
                              {coupon?.description}
                            </p>
                          </div>
                          <div className="flex flex-col items-center justify-center ">
                            <button
                              onClick={() => fillInputWithCode(coupon?.code)}
                              className="text-primary text-lg underline"
                            >
                              Claim
                            </button>
                            <p className="text-xs text-opacity-60 text-primary">
                              {expiryDate(coupon?.expireAt)}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </>
      ) : null}
    </>
  ));
}

export function GetMoreCreditsPopUp({
  popUpInitialValue,
  handlePopup,
  whoPay = false,
  referAndEarnHide,
  availableCoins,
}) {
  const { PopupStore } = useStores();

  const closeThisPopUP = () => {
    PopupStore.setGetMoreCredits(false);
    handlePopup();
  };

  const showGateWayAuto = () => {
    closeThisPopUP();
    PopupStore.setPaymentGateway(true); // Assuming setPaymentGateway accepts credits as an argument
    PopupStore.setCreditPoints("59");
  };

  const showGateWay = () => {
    closeThisPopUP();
    PopupStore.setPaymentGateway(true); // Assuming setPaymentGateway accepts credits as an argument
    PopupStore.setCreditPoints(null);
  };

  const showRedeemCoupon = () => {
    closeThisPopUP();
    PopupStore.setRedeemCoupon(true);
  };

  const showReferAndEarn = () => {
    closeThisPopUP();
    PopupStore.setReferAndEarn(true);
  };
  const [showPurchaseInterviewsPopUp, setShowPurchaseInterviewsPopUp] =
    useState(false);

  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        <div
          onClick={() => closeThisPopUP}
          className="absolute w-screen gil-reg h-screen  z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed inset-0 bg-bg3 z-40 flex flex-col justify-center rounded items-center md:w-[25%] lg:w-[25%] w-[90%] h-[65vh] m-auto overflow-y-auto no-scrollbar"
          >
            <div
              className={`flex flex-col items-center w-[100%] h-[40%]  pt-10
              `}
            >
              <AiFillCloseCircle
                className="text-primary absolute text-2xl cursor-pointer top-4 right-4"
                onClick={closeThisPopUP}
              />
              <FaCoins className="text-primary text-5xl border-b-2 border-bg3" />
              <p className="text-black font-semibold mt-3 text-2xl">
                Get More Credits?
              </p>
              {availableCoins && (
                <p className="text-green-500 gil-med ">
                  Available Credits : {availableCoins}
                </p>
              )}
            </div>

            <div
              className={`flex flex-col w-full h-[70%] justify-center items-start`}
            >
              {/* <div className="flex flex-col items-center w-[90%] h-full mx-auto ">
                <button
                  onClick={() => showGateWayAuto()} // Pass credits amount here
                  className="rounded-xl mt-2 flex items-center justify-center hover:bg-green-300 bg-green-200 text-lg hover:text-black font-semibold text-green-600 py-2 px-4 w-full"
                >
                  Take Interview @ ₹99
                </button>
              </div> */}
              {showPurchaseInterviewsPopUp && (
                <GetCreditsNewPopup
                  onClose={() => setShowPurchaseInterviewsPopUp(false)}
                />
              )}
              <div className="flex flex-col items-center w-[90%] h-auto mx-auto">
                <button
                  onClick={() => {
                    setShowPurchaseInterviewsPopUp(true);
                  }}
                  // onClick={() => showGateWay()} // Without passing credits for generic purchase
                  className="rounded-xl mt-2 flex items-center justify-start hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold text-primary py-2 px-4 w-full"
                >
                  <AiOutlineCreditCard className="mr-4 underline text-2xl" />
                  Purchase Interviews
                </button>
              </div>
              <div className="flex flex-col items-center w-[90%] h-auto mx-auto">
                <button
                  onClick={() => showGateWay()} // Without passing credits for generic purchase
                  className="rounded-xl mt-2 flex items-center justify-start hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold text-primary py-2 px-4 w-full"
                >
                  <AiOutlineCreditCard className="mr-4 underline text-2xl" />
                  Purchase Credits
                </button>
              </div>
              {referAndEarnHide ? null : (
                <div className="flex flex-col items-center w-[90%] h-auto mx-auto">
                  <button
                    onClick={showReferAndEarn}
                    className="rounded-xl mt-2 flex items-center justify-start hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold text-primary py-2 px-4 w-full"
                  >
                    <AiOutlineShareAlt className="mr-4 underline text-2xl" />
                    Refer & Earn
                  </button>
                </div>
              )}

              <div className="flex flex-col items-center w-[90%] h-auto mx-auto">
                <button
                  onClick={showRedeemCoupon}
                  className="rounded-xl mt-2 flex items-center justify-start hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold text-primary py-2 px-4 w-full"
                >
                  <IoTicketOutline className="mr-4 underline text-2xl" />
                  Have a Coupon
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
